/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Library_Morning_BriefingsInputs */

const en_landing_library_morning_briefings = /** @type {(inputs: Landing_Library_Morning_BriefingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morning briefings`)
};

/**
* | output |
* | --- |
* | "Morning briefings" |
*
* @param {Landing_Library_Morning_BriefingsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_library_morning_briefings = /** @type {((inputs?: Landing_Library_Morning_BriefingsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Library_Morning_BriefingsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_library_morning_briefings(inputs)
});